import { c as _c } from "react/compiler-runtime";
import { ecosystemWalletId, THIRDWEB_CLIENT_ID } from "../../../shared/constants/index.js";
import { debugB3React } from "../../../shared/utils/debug.js";
import { client } from "../../../shared/utils/thirdweb.js";
import { useCallback, useState } from "react";
import { useConnect as useConnectTW } from "thirdweb/react";
import { ecosystemWallet } from "thirdweb/wallets";
const debug = debugB3React("useConnect");
/**
 * This hook is used to connect to a wallet using the thirdweb client.
 */
export function useConnect(partnerId, chain) {
  const $ = _c(7);
  if (!chain) {
    throw new Error("Chain is required");
  }
  const {
    connect
  } = useConnectTW();
  const [isLoading, setIsLoading] = useState(false);
  let t0;
  if ($[0] !== chain || $[1] !== connect || $[2] !== partnerId) {
    t0 = async strategyOptions => {
      setIsLoading(true);
      return await connect(async () => {
        if (!strategyOptions) {
          throw new Error("Strategy options are required");
        }
        debug("@@useConnect:strategyOptions", {
          partnerId,
          strategyOptions,
          clientId: THIRDWEB_CLIENT_ID
        });
        const wallet = ecosystemWallet(ecosystemWalletId, {
          partnerId
        });
        const connect_0 = await wallet.connect({
          client,
          chain,
          ...strategyOptions
        });
        debug("@@useConnect:connect:", connect_0);
        setIsLoading(false);
        if (!wallet) {
          throw new Error("Failed to connect");
        }
        return wallet;
      });
    };
    $[0] = chain;
    $[1] = connect;
    $[2] = partnerId;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const connectTw = t0;
  let t1;
  if ($[4] !== connectTw || $[5] !== isLoading) {
    t1 = {
      connect: connectTw,
      isLoading
    };
    $[4] = connectTw;
    $[5] = isLoading;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  return t1;
}